import {
   DRIVING_LICENSE_DURATIONS_NEEDING_LICENSE_DATE_LIST, relationshipsWithPolicyMaker,
   TITLE_OPTIONS,
   YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";
import {isInLabelValueArrayAsString, isValidDateTimeString} from "@utils/validators";
import {isNotStringOrEmptyString} from "@utils/string";
import {isDateGreaterThenToday} from "@utils/date-time";
import {validateAdditionalDrivers} from "@validators/common/sub-components/validate-additional-drivers";

/**
 * @typedef {object} data
 * @property {string} addAdditionalComments
 * @property {string} additionalDrivers
 * @property {string} additionalDrivingQualificationDate
 * @property {string} additionalDrivingQualifications
 * @property {string} britishDrivingLicenseNumber
 * @property {string} vanAlarmsOrImmobiliser
 * @property {string} vanDoorNumber
 * @property {string} vanEngineSize
 * @property {string} vanEstimatedValue
 * @property {string} vanImpoundedWithPolice
 * @property {string} vanMakeAndModel
 * @property {string} vanParkingAtDay
 * @property {string} vanParkingAtNight
 * @property {string} vanPurchased
 * @property {string} vanPurchaseDate
 * @property {string} vanRegistrationNumber
 * @property {string} vanRegistrationYear
 * @property {string} vanSeatNumber
 * @property {string} vanTransmissionType
 * @property {string} contactEmail
 * @property {string} contactPhone
 * @property {string} currentOrPreviousInsurerName
 * @property {string} discoveryType
 * @property {string} drivingLicenseDate
 * @property {string} drivingLicenseDuration
 * @property {string} drivingLicenseType
 * @property {string} dvlaMedicalConditions
 * @property {string} estimatedAnnualMileage
 * @property {string} hasAccidentClaimsInLast5Years
 * @property {string} hasChildrenUnder16
 * @property {string} hasModifications
 * @property {string} hasMotoringConvictionsInLast5Years
 * @property {string} hasNonMotoringCriminalConvictions
 * @property {string} insuranceCoverageStartDate
 * @property {string} insuranceCoverageType
 * @property {string} insurancePaymentType
 * @property {string} insurerName
 * @property {string} isBornInUk
 * @property {string} isVanKeptOnSameAddress
 * @property {string} isVanRegistrationNumKnown
 * @property {string} isHomeOwner
 * @property {string} legalOwner
 * @property {string} mainOccupation
 * @property {string} manufacturerModel
 * @property {string} manufacturerName
 * @property {string} modificationDetails
 * @property {string} modificationType
 * @property {string} motorAccidentsList
 * @property {string} noClaimsDiscount
 * @property {string} occupationIndustry
 * @property {string} otherVehicleUsage
 * @property {string} provideDrivingLicenseNumber
 * @property {string} registeredKeeper
 * @property {string} renewalPriceOfPreviousInsurer
 * @property {string} shouldAddAdditionalDrivers
 * @property {string} termsAgreement
 * @property {string} vehicleKeeperAddress
 * @property {string} vehicleUsageType
 * @property {string} voluntaryExcessAmounts
 * @property {string} wasInsuranceDeclinedBefore
 */

export const ValidateStep4Data = (data) => {

    const msgList = [
      /* {
          name : 'halt',
          message : 'halt'
       }*/
    ];
    
    validateAdditionalDrivers({
       data,
       msgList
    })

    /**
     * Terms agreement
     */

    if (!data.termsAgreement || !data.termsAgreement.trim()) {
        msgList.push({
            name: 'termsAgreement',
            message: 'You must agree to our terms and conditions before application submission'
        });
    }

    return msgList;

}

const validateSingleDriverInfo = (msgList,driver,driverIndex) => {

    let id = driverIndex + 1;

    if (!isInLabelValueArrayAsString(driver.title,TITLE_OPTIONS)) {
        msgList.push({
            name: generateNameForAdditionalDrivers(driverIndex, 'title'),
            message: `Title is required for driver #${id}`
        });
    }
   
   if (isNotStringOrEmptyString(driver.firstName)) {
      msgList.push({
         name: generateNameForAdditionalDrivers(driverIndex, 'firstName'),
         message: `Driver's first name is required for driver #${id}`
      });
   }
   
   if (isNotStringOrEmptyString(driver.lastName)) {
      msgList.push({
         name: generateNameForAdditionalDrivers(driverIndex, 'lastName'),
         message: `Driver's last name is required for driver #${id}`
      });
   }
   
   if (!isValidDateTimeString(driver.birthDate)) {
      msgList.push({
         name: generateNameForAdditionalDrivers(driverIndex, 'birthDate'),
         message: `Driver's birth date is required for driver #${id}`
      });
   } else if(isDateGreaterThenToday(driver.birthDate)) {
      msgList.push({
         name: generateNameForAdditionalDrivers(driverIndex, 'birthDate'),
         message: `Driver's birth date must be in the past for driver #${id}`
      });
   }

    if (!isInLabelValueArrayAsString(driver.relationship,relationshipsWithPolicyMaker)) {
        msgList.push({
            name: generateNameForAdditionalDrivers(driverIndex, 'relationship'),
            message: `Relationship with driver is required for driver #${id}`
        });
    }

    

    

    if (!driver.employmentStatus || !driver.employmentStatus.trim()) {
        msgList.push({
            name: generateNameForAdditionalDrivers(driverIndex, 'employmentStatus'),
            message: `Driver's employment status is required for driver #${id}`
        });
    }


    if (!driver.licenseType || !driver.licenseType.trim()) {
        msgList.push({
            name: generateNameForAdditionalDrivers(driverIndex, 'licenseType'),
            message: `Driver's license type is required for driver #${id}`
        });
    }

    if (!driver.licenseDuration || !driver.licenseDuration.trim()) {
        msgList.push({
            name: generateNameForAdditionalDrivers(driverIndex, 'licenseDuration'),
            message: `Driver's license acquire date is required for driver #${id}`
        });
    }

    if (!driver.dvlaReportedConditions || !driver.dvlaReportedConditions.trim()) {
        msgList.push({
            name: generateNameForAdditionalDrivers(driverIndex, 'dvlaReportedConditions'),
            message: `Please select if there is any DVLA reported conditions for driver #${id}`
        });
    }

    if (!driver.isBornInUK || !driver.isBornInUK.trim()) {
        msgList.push({
            name: generateNameForAdditionalDrivers(driverIndex, 'isBornInUK'),
            message: `Please specify if the driver #${id} was born in UK`
        });
    }

    if(driver.isBornInUK === 'No') {

        if (!isValidDateTimeString(driver.yearObtainingUKResidency)) {
            msgList.push({
                name: generateNameForAdditionalDrivers(driverIndex, 'yearObtainingUKResidency'),
                message: `Please specify which year the driver #${id} got UK residency last`
            });
        } else if(isDateGreaterThenToday(driver.yearObtainingUKResidency)) {
           msgList.push({
                name: generateNameForAdditionalDrivers(driverIndex, 'yearObtainingUKResidency'),
                message: `Please specify which year the driver #${id} got UK residency last`
            });
        }
    }

    if (!driver.useOfOtherVehicles || !driver.useOfOtherVehicles.trim()) {
        msgList.push({
            name: generateNameForAdditionalDrivers(driverIndex, 'useOfOtherVehicles'),
            message: `Please specify if the driver #${id} use any other vehicles`
        });
    }

    if (!driver.unspentNonMotoringCriminalConviction || !driver.unspentNonMotoringCriminalConviction.trim()) {
        msgList.push({
            name: generateNameForAdditionalDrivers(driverIndex, 'unspentNonMotoringCriminalConviction'),
            message: `Please specify if the driver #${id} has any unspent non motoring criminal conviction`
        });
    }



    if (!driver.motorAccidentsOrClaimsIn5Years || !driver.motorAccidentsOrClaimsIn5Years.trim()) {
        msgList.push({
            name: generateNameForAdditionalDrivers(driverIndex, 'motorAccidentsOrClaimsIn5Years'),
            message: `Please specify if the driver #${id} has any moto accidents or claims in last 5 years`
        });
    }

    if(driver.motorAccidentsOrClaimsIn5Years === 'Yes') {

        if(!Array.isArray(driver.motorAccidentsList) || driver.motorAccidentsList.length === 0) {
            msgList.push({
                name: generateNameForAdditionalDrivers(driverIndex, 'motorAccidentsList'),
                message: `Please add one or more incident record(s) for driver #${id}`
            });
        } else {

            driver.motorAccidentsList.forEach((accident,accidentIndex) => {

                /**
                 * Accident type ...
                 */

                if (!accident.type || !accident.type.trim()) {
                    msgList.push({
                        name: generateNameForAccidents(driverIndex, accidentIndex, 'type'),
                        message: `Please specify incident type for incident #${accidentIndex + 1} for driver #${id}`
                    });
                }

                /**
                 * Accident date ...
                 */

                if (!accident.date || !accident.date.trim()) {
                    msgList.push({
                        name: generateNameForAccidents(driverIndex, accidentIndex, 'date'),
                        message: `Please specify incident date for incident #${accidentIndex + 1} for driver #${id}`
                    });
                }

                /**
                 * Accident cost ...
                 */

                if (!accident.cost || !accident.cost.trim()) {
                    msgList.push({
                        name: generateNameForAccidents(driverIndex, accidentIndex, 'cost'),
                        message: `Please specify incident cost for incident #${accidentIndex + 1} for driver #${id}`
                    });
                }

                /**
                 * Accident party at fault ...
                 */

                if (!accident.partyAtFault || !accident.partyAtFault.trim()) {
                    msgList.push({
                        name: generateNameForAccidents(driverIndex, accidentIndex, 'partyAtFault'),
                        message: `Please specify party at fault for incident #${accidentIndex + 1} for driver #${id}`
                    });
                }

                /**
                 * Accident injuries ...
                 */

                if (!accident.hadInjuries || !accident.hadInjuries.trim()) {
                    msgList.push({
                        name: generateNameForAccidents(driverIndex, accidentIndex, 'hadInjuries'),
                        message: `Please specify if there were injuries for the incident #${accidentIndex + 1} for driver #${id}`
                    });
                }


            });

        }

    }

    if (!driver.penaltyPointsIn5Years || !driver.penaltyPointsIn5Years.trim()) {
        msgList.push({
            name: generateNameForAdditionalDrivers(driverIndex, 'penaltyPointsIn5Years'),
            message: `Please specify if the driver #${id} had any motoring convictions, driving licence endorsements or fixed penalty points within the last 5 years`
        });
    }

}

const generateNameForAdditionalDrivers = (index, prop) => {
    return `additionalDrivers.${index}.${prop}`;
}

const generateNameForAccidents = (driverIndex, accidentIndex, accidentProp) => {
    return `additionalDrivers.${driverIndex}.motorAccidentsList.${accidentIndex}.${accidentProp}`;
}